import React from "react";

export const SkeletonLoader = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <div className="animate-pulse flex flex-col items-center">
          <div className="w-24 h-24 bg-gray-300 rounded-full mb-4"></div>
          <div className="w-32 h-6 bg-gray-300 rounded mb-2"></div>
          <div className="w-24 h-4 bg-gray-300 rounded"></div>
        </div>

        <div className="animate-pulse mt-6 space-y-3">
          <div className="h-4 bg-gray-300 rounded w-3/4"></div>
          <div className="h-4 bg-gray-300 rounded w-5/6"></div>
          <div className="h-4 bg-gray-300 rounded w-2/3"></div>
        </div>

        <div className="mt-6 animate-pulse">
          <div className="h-10 bg-gray-300 rounded w-full"></div>
        </div>
      </div>
    </div>
  );
};

export const SkeletonYears = () => (
  <div className="flex overflow-x-auto space-x-6 py-4 w-full justify-center">
    {[...Array(6)].map((_, index) => (
      <div
        key={index}
        className={`w-36 h-36 bg-gray-300 animate-pulse rounded-full ${
          index % 2 === 0 ? "relative -top-4" : "relative top-10"
        }`}
      ></div>
    ))}
  </div>
);

export const SkeletonChapters = () => {
  const skeletonData = [1, 2, 3, 4, "T5"];

  return (
    <div className="flex m-10 gap-5 overflow-x-auto w-full">
      {skeletonData.map((item, index) => (
        <div
          key={index}
          className={`flex-shrink-0 ${
            index % 2 === 0 ? "relative -top-2" : "mb-0"
          }`}
        >
          <div className="w-40 h-28 bg-gray-300 animate-pulse rounded-lg flex items-center justify-center mb-2"></div>
          <div className="w-10 h-10 bg-gray-400 animate-pulse rounded-full flex items-center justify-center text-white font-bold">
            {item}
          </div>
        </div>
      ))}
    </div>
  );
};

export const LessonSkeleton = ({ index }) => (
  <div
    className={`h-96 flex-shrink-0 ${
      index % 2 === 0 ? " mt-[18rem]" : " mt-[28rem]"
    }`}
  >
    <div className="w-64 h-32 bg-gray-200 transform -rotate-3 rounded-lg animate-pulse shadow-lg relative">
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
        <div className="w-12 h-12 bg-gray-400 rounded-full animate-pulse flex items-center justify-center">
          <div className="w-4 h-4 bg-gray-300 rounded-full"></div>
        </div>
      </div>
      <div className="p-4 space-y-2">
        <div className="h-4 bg-gray-300 rounded w-3/4"></div>
        <div className="h-4 bg-gray-300 rounded w-1/2"></div>
      </div>
      <div className="absolute top-2 left-2">
        <div className="w-8 h-8 bg-gray-300 rounded animate-pulse"></div>
      </div>
    </div>
  </div>
);

export const SkeletonVideo = () => {
  return (
    <div className="w-screen h-[600px] bg-gray-300 animate-pulse max-w-[82%] rounded-lg">
      <div className="flex flex-col h-full p-4 space-y-4">
        <div className="w-full h-[70%] bg-gray-400 rounded-lg"></div>
        <div className="w-full h-[10%] bg-gray-400 rounded-lg"></div>
        <div className="w-full h-[10%] bg-gray-400 rounded-lg"></div>
      </div>
    </div>
  );
};

export const SkeletonArrows = () => {
  return (
    <>
      <div className="w-20 h-20 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-20 h-20 bg-gray-300 rounded animate-pulse"></div>
    </>
  );
};

export const SkeletonHeader = () => {
  return (
    <div className="flex items-center gap-5">
      <div className="w-[50px] h-[50px] bg-gray-300 rounded-full animate-pulse"></div>
      <div className="h-6 w-32 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex gap-5">
        <div className="w-12 h-12 bg-gray-300 rounded-full animate-pulse"></div>
        <div className="w-12 h-12 bg-gray-300 rounded-full animate-pulse"></div>
      </div>
    </div>
  );
};

export const SkeletonDOB = () => {
  return (
    <div className="space-y-4 animate-pulse">
      <div className="h-8 w-64 bg-gray-200 rounded-md"></div>
      <div className="h-12 w-full max-w-md bg-gray-200 rounded-lg"></div>
      <div className="h-12 w-32 bg-gray-200 rounded-full mx-auto mt-6"></div>
    </div>
  );
};

export const SkeletonAvatar = () => {
  return (
    <div className="space-y-4 animate-pulse">
      <div className="h-8 w-48 bg-gray-200 rounded-md"></div>
      <div className="grid grid-cols-5 gap-4">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="aspect-square bg-gray-200 rounded-full"></div>
        ))}
      </div>
      <div className="h-12 w-32 bg-gray-200 rounded-full mx-auto mt-6"></div>
    </div>
  );
};
